package com.fireavert.administration.super_admin_tools_page.client.presentation

import com.fireavert.administration.super_admin_tools_page.data_models.data_model.SmokeAlarmDurationRecordModel
import com.fireavert.administration.super_admin_tools_page.data_models.models.PropertyNotificationStatsModel
import com.fireavert.administration.super_admin_tools_page.data_models.models.PropertyOfflineStatisticsModel
import com.fireavert.administration.users_page.main_user_page.data_models.data_model.UserDTO
import com.fireavert.common.ViewModel
import com.fireavert.properties.shared.data_models.Property
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

class WirelessIdSectionViewModel : WirelessIdSectionScreen, ViewModel() {
    private val _viewState = MutableStateFlow(WirelessIdSectionViewState())
    val viewState = _viewState.asStateFlow()

    val scope: CoroutineScope = viewModelScope
    override var percentageOfDevicesOfflineSetting: Int
        get() {
            return viewState.value.devicesOfflineSetting
        }
        set(value) {
            _viewState.value = _viewState.value.copy(devicesOfflineSetting = value)
        }
    override var notificationsEnabled: Boolean
        get() {
            return viewState.value.notificationsEnabled
        }
        set(value) {
            _viewState.value = _viewState.value.copy(notificationsEnabled = value)
        }
    override var wirelessDeviceId: String
        get() { return viewState.value.wirelessDeviceId }
        set(value) {
            _viewState.value = _viewState.value.copy(wirelessDeviceId = value)
        }
    override var propertyName: String
        get() = viewState.value.propertyName
        set(value) { _viewState.value = _viewState.value.copy(propertyName = value) }
    override var unitName: String
        get() = viewState.value.unitName
        set(value) { _viewState.value = _viewState.value.copy(unitName = value) }
    override var deviceLocationLink: String
        get() = viewState.value.deviceLocationLink
        set(value) { _viewState.value = _viewState.value.copy(deviceLocationLink = value) }
    override var gatewayDeviceData: Map<String, List<String>>
        get() = viewState.value.gatewayDeviceData
        set(value) { _viewState.value = _viewState.value.copy(gatewayDeviceData = value) }
    override var gatewayDeviceDataLoading: Boolean
        get() = viewState.value.gatewayDeviceDataLoading
        set(value) { _viewState.value = _viewState.value.copy(gatewayDeviceDataLoading = value) }
    override var propertyOfflineStatistics: List<PropertyOfflineStatisticsModel>
        get() = viewState.value.propertyOfflineStatistics
        set(value) { _viewState.value = _viewState.value.copy(propertyOfflineStatistics = value) }
    override var propertyNotificationStats: List<PropertyNotificationStatsModel>
        get() = viewState.value.propertyNotificationStats
        set(value) { _viewState.value = _viewState.value.copy(propertyNotificationStats = value) }
    override var propertySmokeAlarmDurationStats: List<SmokeAlarmDurationRecordModel>
        get() = viewState.value.propertySmokeAlarmDurationStats
        set(value) {
            _viewState.value = _viewState.value.copy(propertySmokeAlarmDurationStats = value)
        }
    override var propertyStatsLoading: Boolean
        get() = viewState.value.propertyStatsLoading
        set(value) { _viewState.value = _viewState.value.copy(propertyStatsLoading = value) }
    override var appsheetDatabaseHealthStatus: Boolean
        get() = viewState.value.appsheetDatabaseHealthStatus
        set(value) { _viewState.value = _viewState.value.copy(appsheetDatabaseHealthStatus = value) }
    override var appsheetDatabaseHealthLoading: Boolean
        get() = viewState.value.appsheetDatabaseHealthLoading
        set(value) { _viewState.value = _viewState.value.copy(appsheetDatabaseHealthLoading = value) }
    override var testEmailSending: Boolean
        get() = viewState.value.testEmailSending
        set(value) { _viewState.value = _viewState.value.copy(testEmailSending = value) }
    override var testEmailResponse: String
        get() = viewState.value.testEmailResponse
        set(value) { _viewState.value = _viewState.value.copy(testEmailResponse = value) }
    override var adminUsers: List<UserDTO>?
        get() = viewState.value.adminUsers
        set(value) { _viewState.value = _viewState.value.copy(adminUsers = value) }
    override var appsheetDatabaseLastChecked: String
        get() = viewState.value.appsheetDatabaseLastChecked
        set(value) { _viewState.value = _viewState.value.copy(appsheetDatabaseLastChecked = value) }
    override var propertyList: List<Property>
        get() = viewState.value.propertyList
        set(value) { _viewState.value = _viewState.value.copy(propertyList = value) }
}